export default __webpack_public_path__ + "static/media/cat-5-5.07a5b56d.jpg";